import PropTypes from 'prop-types';
import { formatDate, toSentenceCase } from 'utils';

import { Box } from '@mui/material';

import { CALL_EVENTS_NAMES } from './constants';

import { timeOnlyFormat } from '../../staticData';
import StyledExpanderLine from '../Forms/StyledExpanderLine';

const CallEventsComponent = ({ row, t }) => {
  const callEvents = row?.original?.callEvents || row?.callEvents;
  return (
    <StyledExpanderLine>
      {!callEvents?.length ? (
        <Box p="2rem">{t('remoteDoorman.noEvents')}</Box>
      ) : (
        <Box p="2rem" ml="2.5rem" fontSize="1.5rem">
          <Box display="flex" fontWeight="bold">
            <Box>{t('remoteDoorman.time')}</Box>
            <Box ml="3rem" />
            <Box>{t('title.action')}</Box>
          </Box>
          <Box>
            {callEvents?.map(({ timestamp, name, callCenterAgent }) => {
              const date = formatDate(timestamp, true, timeOnlyFormat);
              const eventName = CALL_EVENTS_NAMES[name] || toSentenceCase(name);
              const agentName = callCenterAgent?.name
                ? `- ${callCenterAgent?.name}`
                : ``;
              const eventInfo = `${date} ${eventName} ${agentName}`;
              return <Box key={timestamp + name}>{eventInfo}</Box>;
            })}
          </Box>
        </Box>
      )}
    </StyledExpanderLine>
  );
};

CallEventsComponent.propTypes = {
  row: PropTypes.instanceOf(Object).isRequired,
  t: PropTypes.func.isRequired,
};

export default CallEventsComponent;
